const OsanoStyles = theme => ({
  '.osano-cm-window': {
    zIndex: 2147483647,
  },
  '.osano-cm-dialog *, .osano-cm-info *': {
    fontFamily: theme.typography.fontFamily,
    fontSize: '.75rem',
  },
  '.osano-cm-dialog': {
    maxWidth: '500px !important',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.border.radius,
  },
  '.osano-cm-message': {
    marginBottom: '6px',
  },
  '.osano-cm-link': {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    padding: '10px 0',
    textTransform: 'lowercase',
  },
  '.osano-cm-link::first-letter': {
    textTransform: 'uppercase',
  },
  '.osano-cm-link:hover': {
    color: theme.palette.button.textHover,
  },
  '.osano-cm-storage-policy::before': {
    content: '"To learn more, visit our "',
    top: 0,
    left: 0,
    color: theme.palette.common.black,
  },
  '.osano-cm-storage-policy::after': {
    content: '"."',
    top: 0,
    right: 0,
    color: theme.palette.common.black,
  },
  '.osano-cm-dialog__buttons': {
    display: 'block',
  },
  '.osano-cm-button': {
    textTransform: 'lowercase',
    padding: '10.5px 12px',
    borderRadius: theme.border.radius,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.875rem',
    marginBottom: '8px',
  },
  '.osano-cm-button::first-letter': {
    textTransform: 'uppercase',
  },
  '.osano-cm-button:hover, .osano-cm-button:focus, .osano-cm-button:active': {
    backgroundColor: theme.palette.primary.light2,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  '.osano-cm-button.osano-cm-button--type_manage': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  '.osano-cm-info': {
    maxWidth: '30em',
  },
  '.osano-cm-header': {
    fontFamily: theme.typography.bold.fontFamily,
    fontSize: '1.25rem',
    background: theme.palette.common.white,
  },
  '.osano-cm-description:last-of-type': {
    marginTop: '6px',
    marginBottom: '24px',
  },
  '.osano-cm-label': {
    fontFamily: theme.typography.bold.fontFamily,
    fontSize: '1rem !important',
  },
  '.osano-cm-label::first-letter': {
    textTransform: 'uppercase',
  },
  '.osano-cm-drawer-item': {
    paddingTop: 0,
  },
  '.osano-cm-toggle': {
    fontFamily: theme.typography.bold.fontFamily,
    textTransform: 'lowercase',
  },
  '.osano-cm-toggle::first-letter': {
    textTransform: 'uppercase',
  },
  '.osano-cm-toggle:hover': {
    cursor: 'pointer',
  },
  '.osano-cm-disclosure__toggle': {
    color: theme.palette.primary.main,
    fontFamily: theme.typography.fontFamily,
  },
  '.osano-cm-disclosure__toggle:hover': {
    color: theme.palette.common.black,
  },
  '.osano-cm-toggle__input + .osano-cm-toggle__switch, .osano-cm-toggle__input:focus + .osano-cm-toggle__switch, .osano-cm-toggle__input:hover + .osano-cm-toggle__switch': {
    backgroundColor: theme.palette.grey[100],
  },
  '.osano-cm-toggle__input + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:focus + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:hover + .osano-cm-toggle__switch::after': {
    backgroundColor: theme.palette.common.white,
  },
  '.osano-cm-toggle__input:checked + .osano-cm-toggle__switch, .osano-cm-toggle__input:checked:focus + .osano-cm-toggle__switch, .osano-cm-toggle__input:checked:hover + .osano-cm-toggle__switch': {
    backgroundColor: theme.palette.primary.main,
  },
  '.osano-cm-toggle__input:checked + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:checked:focus + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:checked:hover + .osano-cm-toggle__switch::after': {
    backgroundColor: theme.palette.common.white,
  },
  '.osano-cm-toggle__input:disabled:checked + .osano-cm-toggle__switch, .osano-cm-toggle__input:disabled:checked:focus + .osano-cm-toggle__switch, .osano-cm-toggle__input:disabled:checked:hover + .osano-cm-toggle__switch': {
    backgroundColor: theme.palette.primary.main,
    opacity: 0.5,
  },
  '.osano-cm-toggle__input:disabled:checked + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:disabled:checked:focus + .osano-cm-toggle__switch::after, .osano-cm-toggle__input:disabled:checked:hover + .osano-cm-toggle__switch::after': {
    backgroundColor: theme.palette.common.white,
  },
  '.osano-cm-view__button': {
    width: 'auto',
  },
  '.osano-cm-powered-by__link': {
    display: 'none',
  },
  '.osano-cm-info-dialog-header__close:focus': {
    backgroundColor: 'transparent',
    border: 'transparent',
  },
  '.osano-cm-close:focus, .osano-cm-close:hover': {
    transform: 'none !important',
  },
  '.osano-cm-info-dialog-header__close svg': {
    stroke: theme.palette.common.black,
    width: '14px',
    height: '14px',
  },
  '.osano-cm-widget': {
    display: 'none',
  },
});

export default OsanoStyles;
